module.exports = __webpack_public_path__ + "static/img/stlogo.ba0df87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stlogo.png
// module id = /plo
// module chunks = 1